import * as Types from '../types';

import { gql } from '@apollo/client';
export type ConversationItemContentChildren_ImageNode_Fragment = { __typename?: 'ImageNode' };

export type ConversationItemContentChildren_LineBreakNode_Fragment = { __typename?: 'LineBreakNode', version: number, type: string };

export type ConversationItemContentChildren_LinkNode_Fragment = { __typename?: 'LinkNode', version: number, type: string, indent: number, url: string, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> };

export type ConversationItemContentChildren_TextNode_Fragment = { __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string };

export type ConversationItemContentChildrenFragment = ConversationItemContentChildren_ImageNode_Fragment | ConversationItemContentChildren_LineBreakNode_Fragment | ConversationItemContentChildren_LinkNode_Fragment | ConversationItemContentChildren_TextNode_Fragment;

export type ConversationItemContentFragment = { __typename?: 'RootNode', version: number, type: string, indent: number, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'CodeBlockNode' } | { __typename?: 'HeadingNode' } | { __typename?: 'IframeNode' } | { __typename?: 'ListNode' } | { __typename?: 'ParagraphNode', version: number, type: string, indent: number, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'ImageNode' } | { __typename?: 'LineBreakNode', version: number, type: string } | { __typename?: 'LinkNode', version: number, type: string, indent: number, url: string, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> } | { __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> } | { __typename?: 'QuoteNode' }> };

export type ConversationItemFragment = { __typename?: 'ConversationItem', _id: string, conversationId: string, createdAt: string, senderType: Types.ConversationSenderType, card?: { __typename?: 'ConversationCard', type: Types.ConversationCardType, link?: string | null, image?: string | null, title?: string | null, appIcon?: string | null, appTitle?: string | null, createdBy: Types.ConversationCardSender, description?: string | null } | null, buttons: Array<{ __typename?: 'ConversationItemButton', _id: string, text: string, type: Types.ConversationItemButtonType, action_type: Types.ConversationItemButtonActionType, url?: string | null, target?: Types.ConversationItemButtonTarget | null, event_name?: string | null, event_payload?: string | null }>, attachments: Array<{ __typename?: 'Attachment', _id: string, pending: boolean, uploaded: boolean, fileName: string, extension: string, size?: number | null, url?: string | null, uploadUrl?: string | null }>, content: { __typename?: 'ConversationContent', type: Types.ConversationContentType, messageString?: string | null, message: { __typename?: 'RootNode', version: number, type: string, indent: number, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'CodeBlockNode' } | { __typename?: 'HeadingNode' } | { __typename?: 'IframeNode' } | { __typename?: 'ListNode' } | { __typename?: 'ParagraphNode', version: number, type: string, indent: number, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'ImageNode' } | { __typename?: 'LineBreakNode', version: number, type: string } | { __typename?: 'LinkNode', version: number, type: string, indent: number, url: string, format?: string | null, direction?: string | null, children: Array<{ __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> } | { __typename?: 'TextNode', version: number, type: string, detail: number, format?: string | null, mode: string, style: string, text: string }> } | { __typename?: 'QuoteNode' }> } }, sender: { __typename?: 'APIIntegration', logoURL?: string | null, displayName?: string | null, displayDescription?: string | null } | { __typename?: 'MemberUser', name?: string | null, lastName: string, firstName: string, logoURL?: string | null } | { __typename?: 'Visitor', _id: string, name?: string | null, image?: string | null } };

export const ConversationItemContentChildrenFragmentDoc = gql`
    fragment ConversationItemContentChildren on InlineNode {
  ... on TextNode {
    version
    type
    detail
    format
    mode
    style
    text
  }
  ... on LineBreakNode {
    version
    type
  }
  ... on LinkNode {
    version
    type
    indent
    url
    format
    direction
    children {
      version
      type
      detail
      format
      mode
      style
      text
    }
  }
}
    `;
export const ConversationItemContentFragmentDoc = gql`
    fragment ConversationItemContent on RootNode {
  version
  type
  indent
  format
  direction
  children {
    ... on ParagraphNode {
      version
      type
      indent
      format
      direction
      children {
        ...ConversationItemContentChildren
      }
    }
  }
}
    ${ConversationItemContentChildrenFragmentDoc}`;
export const ConversationItemFragmentDoc = gql`
    fragment ConversationItem on ConversationItem {
  _id
  conversationId
  createdAt
  senderType
  card {
    type
    link
    image
    title
    appIcon
    appTitle
    createdBy
    description
  }
  buttons {
    _id
    text
    type
    action_type
    url
    target
    event_name
    event_payload
  }
  attachments {
    _id
    pending
    uploaded
    fileName
    extension
    size
    url
    uploadUrl
  }
  content {
    type
    messageString
    message {
      ...ConversationItemContent
    }
  }
  sender {
    ... on APIIntegration {
      logoURL
      displayName
      displayDescription
    }
    ... on Visitor {
      _id
      name
      image
    }
    ... on MemberUser {
      name
      lastName
      firstName
      logoURL
    }
  }
}
    ${ConversationItemContentFragmentDoc}`;